import { pool } from "@nostr/gadgets/global";
import { loadNostrUser, type NostrUser } from "@nostr/gadgets/metadata";
import type { NostrEvent } from "@nostr/tools";
import {
  fetchRelayInformation,
  type RelayInformation
} from "@nostr/tools/nip11";
import { normalizeURL } from "@nostr/tools/utils";

export const relay =
  (() => {
    let metas = document.head.querySelectorAll("meta");
    for (let i = 0; i < metas.length; i++) {
      const meta = metas[i];
      switch (meta.name) {
        case "relay":
          return normalizeURL(meta.content);
      }
    }
    return undefined;
  })() || normalizeURL(location.protocol + "//" + location.host);

loadRelayInfo();
loadLabels();
loadTopics();

export const info = $state<
  Pick<RelayInformation, "name" | "description" | "icon">
>({
  name: relay,
  description: "",
  icon: new URL("/favicon.ico", relay).toString()
});

export function loadRelayInfo() {
  fetchRelayInformation(relay).then((resp) => {
    info.name = resp.name || relay;
    info.description = resp.description || "";
    info.icon = new URL(resp.icon || "/favicon.ico", relay).toString();
  });
}

export let topics = $state<NostrEvent[]>([]);
export let counts = $state<{ [id: string]: number }>({});
export let lastcomment = $state<{ [id: string]: NostrEvent }>({});

export function loadTopics() {
  let eosed = false;
  let events: NostrEvent[] = [];
  pool.subscribe(
    [relay],
    { kinds: [11], limit: 40 },
    {
      label: "topics",
      onevent(evt) {
        addToKnownUsers(evt.pubkey);

        if (eosed) {
          topics.push(evt);
        } else {
          events.push(evt);
        }

        // fetch count
        pool.ensureRelay(relay).then(async (r) => {
          counts[evt.id] = await r.count(
            [{ kinds: [1111], "#E": [evt.id] }],
            {}
          );
        });

        // fetch last comment
        pool
          .get([relay], { kinds: [1111], limit: 1, "#E": [evt.id] })
          .then((l) => {
            if (l) {
              lastcomment[evt.id] = l;
            }
          });
      },
      oneose() {
        eosed = true;
        events.reverse();
        topics.splice(0, 0, ...events);
        events = [];
      }
    }
  );
}

export const labels = $state<string[]>([]);
export const addedLabels = $state<{ [id: string]: string[] }>({});

export function loadLabels() {
  const subc = pool.subscribe(
    [relay],
    { kinds: [1985], "#L": ["#t"] },
    {
      label: "labels",
      onevent(evt) {
        addToKnownUsers(evt.pubkey);

        const e = evt.tags.find((t) => t[0] === "e")?.[1];
        if (e) {
          const label = evt.tags.find((t) => t[0] === "l")?.[1];
          if (label) {
            let added = addedLabels[e];
            if (added) {
              if (!added.includes(label)) added.push(label);
            } else {
              added = [label];
              addedLabels[e] = added;
            }

            if (!labels.includes(label)) labels.push(label);
          }
        }
      }
    }
  );
  return subc.close;
}

export const knownUsers = $state<NostrUser[]>([]);

export async function addToKnownUsers(pubkey: string) {
  if (knownUsers.find((existing) => existing.pubkey === pubkey)) return;

  const nu = await loadNostrUser(pubkey);
  if (nu.metadata.name) {
    knownUsers.push(nu);
  }
}
